export default {
  namespace: 'goodsList',
  state: {
    tab: '1',
  },
  reducers: {
    tabswitch( state, { payload: tab } ) {
      return {...state, tab}
    },
  },
  //ef
};
